import { PurchaseOrderAllocation } from './purchase-order-allocation';

export interface PurchaseOrderAllocations {
  id: string;
  purchaseOrderAndLineNo: string;
  supplierKey: string;
  supplierName: string;
  productKey: string;
  productDescription: string;
  productType: string;
  allocations: PurchaseOrderAllocation[];
}
